<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="file_033"><img alt="Image" src="images/f0018-01.jpg"/></a></p><a id="file_033">
<p class="caption">Near Naval Air Station San Diego, a trio of Grumman F2F-1 fighters assigned to VF-2 demonstrates a razzle-dazzle formation. In large groups, the odd positioning of the aircraft gave the formation a confusing, chaotic appearance. This image was taken on July 7, 1937. <em>Grumman History Center</em></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_033.vue?07aec19d